import React, { useState, useEffect } from "react";
import ReactIdSwiper from "react-id-swiper";

export default (props) => {
  // //console.log(props);
  var data = props.data;
  // Swiper instance
  const [swiper, updateSwiper] = useState(null);
  // Slides current index
  const [currentIndex, updateCurrentIndex] = useState(0);
  var elePagi = ".swiper-pagination";
  if (props.page == "home-banners") {
    elePagi = ".swiper-pagination.swiper-pagination-white";
  }
  var params = {};
  // Params definition
 (props.page == "dr-carousel-unit")
    params = {
      loop: true,
        slidesPerView: 1.2,
        spaceBetween: 16,
         breakpoints: {
        767: {
          slidesPerView: 1.2,
          spaceBetween: 16
        },
      },
      getSwiper: updateSwiper // Get swiper instance callback
    }
  

  // Manipulate swiper from outside
  const goNext = () => {
    if (swiper !== null) {
      swiper.slideNext();
    }
  };

  const goPrev = () => {
    if (swiper !== null) {
      swiper.slidePrev();
    }
  };

  // Add eventlisteners for swiper after initializing
  useEffect(() => {
    if (swiper !== null) {
      swiper.on("slideChange", () => updateCurrentIndex(swiper.realIndex));
    }

    return () => {
      if (swiper !== null) {
        swiper.off("slideChange", () => updateCurrentIndex(swiper.realIndex));
      }
    };
  }, [swiper]);

  return (
    <div>
      <ReactIdSwiper {...params}>
        {data.map((item, idx) => (
          (props.page == "dr-carousel-unit" ?
            <div className="swiper-slide_feed " key={idx}>
                <div className="slider_might_intrested_main_content">
                     <div className="new_born_opacity">
                     <a href="#">
                       <img src={item.img} alt={item.name} title={item.name}/>
                      </a>
                     </div>
                     <div className="new_artical_name_content">
                        <div className="baby_name_text M18_white"> {item.name} </div>
                     </div>
                </div>
                <div className="might_intrested_slider_content">
                  <div className="baby-week-social-view social_padding_group"> 
                      <div className="post-options">
                        <div className="icon left devMemoLike font-sizeview" data-icon-font="$"> <span className="icons-text R13_42"> 124</span> </div>
                        <div className="icon left" data-icon-font="e"> <span className="icons-text R13_42"> 10k Post </span> </div>
                      </div>
                     <div className="m-abuse-main right">
                       <div className="icon left icon3dot" data-icon-font="?"> <span className="icons-text font-sizeview_user R13_42"> 5k Members </span></div>
                     </div>
                 </div>
                 <div className="groups_you_might_join"> 
                    <div className="gorups_profiles_view">
                      <div className="gorups_profiles_view_pic group_over1">
                        <div className="gorups_pro_pic_22"> 
                          <img src="../../../../images/face2.webp" alt=""/>
                        </div> 
                        <div className="gorups_pro_pic_22 group_over2"> 
                          <img src="../../../../images/face3.webp" alt=""/>
                        </div>
                        <div className="gorups_pro_pic_22 group_over3"> 
                          <img src="../../../../images/face4.webp" alt=""/>
                        </div>
                      </div>
                        <div className="gorups_profiles_view_text R14_42"> Sandeep and 2 friends are members</div>
                    </div> 
                    <div className="btn_group_join_common">
                      <button className="M15_white" type="button" tabIndex={0} aria-label="Join"> JOIN </button>
                    </div>
                  </div>
                </div>
            </div>
            :
            <div className="swiper-slide_feed" key={idx}>
              <img src="https://bbcdnlivemumbai.s3.ap-south-1.amazonaws.com/brainbees/community/memoryimages/1584339297p4706331.jpeg" alt="" />
            </div>
          )
        ))}
      </ReactIdSwiper>
      <div className="buttons buttons-list" style={{ display: "none" }}>
        <button id="prevSlide" className="button is-primary" onClick={goPrev} aria-label="Previous">
          Prev
        </button>
        <button id="nextSlide" className="button is-primary" onClick={goNext} aria-label="Next">
          Next
        </button>
      </div>
    </div>
  );
};
